import { render, staticRenderFns } from "./ReactMountCupom.vue?vue&type=template&id=649362ed"
import script from "./ReactMountCupom.vue?vue&type=script&lang=ts"
export * from "./ReactMountCupom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649362ed')) {
      api.createRecord('649362ed', component.options)
    } else {
      api.reload('649362ed', component.options)
    }
    module.hot.accept("./ReactMountCupom.vue?vue&type=template&id=649362ed", function () {
      api.rerender('649362ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountCupom.vue"
export default component.exports